export enum UserViewMode {
  ByGroup = 1,
  ByCompany = 2,
  ByStatus = 3,
  ByRole = 4,
  ByInvestigativeSite = 5,
  ByInvestigativeSiteMainContactsOnly = 6,
  ByAction = 7,
  ByUsername = 8,
  ByOrganization = 10,
}
